
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import DocsLayout from '../../components/DocsLayout'
import NextPage from '../../components/NextPage'
import Primary from '../../sections/api/primary/index.md'
import Helpers from '../../sections/api/helpers/index.md'
import SupportedCSS from '../../sections/api/supported-css.md'
import Flow from '../../sections/api/flow.md'
import TypeScript from '../../sections/api/typescript.md'
import OldAPIs from '../../sections/api/old/index.md'
import TestUtilities from '../../sections/api/test-utils/index.md'


const layoutProps = {
  
};
const MDXLayout = ({ children }) => (
  <DocsLayout title="API Reference" description="API Reference of styled-components">
    {children}
  </DocsLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Primary mdxType="Primary" />
    <Helpers mdxType="Helpers" />
    <TestUtilities mdxType="TestUtilities" />
    <SupportedCSS mdxType="SupportedCSS" />
    <Flow mdxType="Flow" />
    <TypeScript mdxType="TypeScript" />
    <OldAPIs mdxType="OldAPIs" />
    <NextPage href="/docs/tooling" title="Tooling" mdxType="NextPage" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;